<template>
  <div class="form-row">
    <div class="form-group col-12 col-md-8">
      <label for="logradouro">Razão Social</label>
      <input type="text" class="form-control form-control-lg" v-model="partner.RazaoSocial" required placeholder="Razão Social">
    </div>
    <div class="form-group col-12 col-md-4">
      <label for="inputPassword4">CNPJ</label>
      <input type="text" class="form-control form-control-lg" v-model="partner.Cnpj" required v-mask="'cnpj'" placeholder="CNPJ">
    </div>
    <div class="form-group col-12 col-md-4">
      <label for="Celular">Celular</label>
      <input type="text" class="form-control form-control-lg" v-model="partner.Celular" required placeholder="" v-mask="'phone'">
    </div>
    <div class="form-group col-12 col-md-8">
      <label for="Email">Email</label>
      <input type="email" class="form-control form-control-lg" v-model="partner.Email" required placeholder="">
    </div>
    <div class="form-group col-12 col-md-4">
      <label for="Site">Site</label>
      <input type="text" class="form-control form-control-lg" v-model="partner.Site" placeholder="Ex: iouu.com.br">
    </div>
    <div class="form-group col-12 col-md-4">
      <label for="Facebook">Facebook</label>
      <input type="text" class="form-control form-control-lg" v-model="partner.Facebook" placeholder="Ex: facebook.com/IouuBrasil/">
    </div>
    <div class="form-group col-12 col-md-4">
      <label for="Linkedin">Linkedin</label>
      <input type="text" class="form-control form-control-lg" v-model="partner.Linkedin" placeholder="Ex: linkedin.com/company/iouu/">
    </div>
  </div>
</template>

<style scoped lang="scss">
.form-row {
  margin-bottom: 2.5rem;
}
</style>

<script>
export default {
  props: {
    partner: { required: true, type: Object }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/GuarantorsStep/CompanyFields.vue